// extracted by mini-css-extract-plugin
export var scrTable = "styles-module--scrTable--uTroI";
export var scrollContainer = "styles-module--scrollContainer--lh-gf";